





















import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
import {translate} from "@/services/translation/translation";
import './_number-slider.less';
import $ from 'jquery';
import {goToTop} from "@/services/position/position";
import {string} from "prop-types";
import vueSlider from 'vue-slider-component'
import {getHtmlUnit} from "@/services/unit/unit";

@Component({
    components: {
        vueSlider,
    }
})

export default class numberSlider extends Vue {
    @Prop() model;

    private data: any = {
        model: null,
        options: {
            min: 0,
            max: 100000000000000
        }
    };

    mounted() {
        goToTop('', this.model.componentSetting.id);
        this.data.model = typeof this.model.componentSetting.default == "string" ? parseInt(this.model.componentSetting.default) : 0;
        this.data.options.min = typeof this.model.componentSetting.min == "string" ? parseInt(this.model.componentSetting.min) : 0;
        this.data.options.max = typeof this.model.componentSetting.max == "string" ? parseInt(this.model.componentSetting.max) : 0;


    }


    getUnitView(unit){
        return getHtmlUnit(unit);
    }


    trans(key) {
        return translate(key);
    }

    @Watch("model", {immediate: true, deep: true})
    changeModel(newVal, oldVal){
        if(this.data.model != null && (this.model.value_id == "" || this.model.value == "" ) ){
            this.changeComponentSettingModel(this.data.model);
        }
    }

    @Watch("data.model", {immediate: true, deep: true})
    changeComponentSettingModel(newValue) {
        let componentValue :any = {};
        componentValue.id = this.model.componentSetting.id;
        componentValue.name = this.model.componentSetting.name;
        componentValue.value = newValue;
        componentValue.value_id = this.model.componentSetting.id;
        componentValue.next_question = this.model.componentSetting.next_question;
        componentValue.isEnableNext = this.model.isEnableNext;
        this.onSelectedQuestionValue(componentValue);

    }

    @Emit("selectedQuestionValue")
    onSelectedQuestionValue(value) {
    }

}

